
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material"
import { useOrdenCompraXID } from "../../hooks";
import { iconos } from "../../data";
import dayjs from "dayjs";



export const DisenioOrdenCompra = ({ children, titulo }) => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { data } = useOrdenCompraXID(id);
    

    
    return (

        <Box sx={{ display:'flex', flexDirection:'column', width:'100%', height:'100%',
            backgroundColor:'white', p:4, minHeight:0, overflowY:'auto', overflowX:'hidden',
        }}>
            <Box sx={{ display:'flex', alignItems:'center', mb:1.5 }}>
                <Typography variant='h4'>{ titulo }</Typography>

                <Box flex={1} />
                <Button variant="contained" color='secondary'
                    sx={{ color: '#fff', ':hover': { opacity: 0.5 }, py:1 }} onClick={() => navigate(-1)}>
                    { iconos['back'] } 
                </Button>
            </Box>

            {(data) &&
            <Box sx={{width:'100%'}}>
                <Box sx={{display:'flex', alignItems:'center', justifyContent:'start'}}>
                    { React.cloneElement(iconos['setting'], {style:{ color:'#8B8B8B'} })}
                    <Typography variant='h5' ml={0.5} sx={{color:'#8B8B8B'}}>
                        {`Orden # ${data.numero} - ${dayjs(data.createdAt).format("DD/MMM/YY hh:mm A")}`}
                    </Typography>
                </Box>

                <Box sx={{width:'100%'}}>
                    <Box sx={{ mb:3, mt:1, height:"1.3px", background:"#8B8B8B", width:"100%" }} />
                </Box>
            </Box>
            }

            {/* Contenido */}
            <Box sx={{ flex:1, display:'flex', flexDirection:'column' }}>
                {children}
            </Box>
        </Box>
    )

    
}
